export const RECENT_REQUESTS_MAX_TO_SHOW = 5
